import * as z from 'zod';

import { InterestOnEscrowDepositHistoryItemId, PaymentId } from '../BrandedIds';
import { zodJSPlainDate } from '../dates/BrandedDate';

/**
 * The intended usage is to look up the latest non-reversed interest on escrow deposit in the paymentsMade array
 * and use its interestOnEscrowDepositHistoryItemId to locate the startOfNextAccrualPeriod in this array.
 * The startOfNextAccrualPeriod is then used to calculate the total accrued interest from that date
 * to the report's end date.
 *
 * The cancelled flag is set to true when the corresponding deposit is reversed.
 */
export const InterestOnEscrowDepositHistoryItem = z.object({
  id: InterestOnEscrowDepositHistoryItemId,
  paymentId: PaymentId,
  startOfNextAccrualPeriod: zodJSPlainDate,
  cancelled: z.boolean().optional(),
});
export type InterestOnEscrowDepositHistoryItem = z.infer<typeof InterestOnEscrowDepositHistoryItem>;

export const InterestOnEscrowDepositHistoryItemInput = InterestOnEscrowDepositHistoryItem.omit({
  id: true,
  paymentId: true,
  cancelled: true,
});
export type InterestOnEscrowDepositHistoryItemInput = z.infer<typeof InterestOnEscrowDepositHistoryItemInput>;
